import _ from '@lodash';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import MeasurementService from 'app/admin/measurement/service/MeasurementService';
import { useWhatIf } from './WhatIfProvider';

function WhatIfMeasurementSelect() {
	const { t } = useTranslation('whatIf');
	const { data, setData } = useWhatIf();

	const schema = yup.object().shape({ aspect: yup.number().nullable().required(t('validation:FIELD_REQUIRED')) });

	const methods = useForm({ defaultValues: { measurement: _.get(data, 'properties.measurement', null) }, mode: 'onChange', resolver: yupResolver(schema) });

	const handleChange = value => {
		if (!_.isUndefined(value)) setData({ ...data, properties: { ..._.get(data, 'properties', {}), ...methods.getValues() } });
	};

	return (
		<FormProvider {...methods}>
			<div className="flex flex-row">
				<Controller
					control={methods.control}
					name="measurement"
					render={({ field, fieldState }) => (
						<EditFormSelectField
							field={field}
							fieldState={fieldState}
							config={{ topic: 'whatIf' }}
							fieldConfig={{
								key: 'measurement',
								text: t('measurement'),
								// type: 'enum',
								onChange: handleChange,
								items: () => MeasurementService.getListSelection()
							}}
						/>
					)}
				/>
			</div>
		</FormProvider>
	);
}

export default WhatIfMeasurementSelect;
